<form id="adjustEndTimeForm" [formGroup]="adjustEndTimeForm" autocomplete="off">
  <div class="form-group col-md-12">
    <label class="control-label required">{{'i18n.domain.parker-registration.adjust-parker-registration-dialog.function-forms.endTime' | translate}}</label>
    <ejs-datetimepicker id="endTime" formControlName="endTime"
                        timeFormat="HH:mm"
                        format="dd.MM.yyyy HH:mm"
                        [min]="minDate">
    </ejs-datetimepicker>
    <app-error-messages [control]="adjustEndTimeForm.controls.endTime"></app-error-messages>
  </div>
</form>
